import React from 'react';
import Icon from '../../../../../../../../../../components/icon';
import {dropDownPosition} from '../../../../../../../../../../utils';
import {connect} from "react-redux";
import {putUpdateCollaborators} from "../../../../../../../../../../../actions/sharingDetailsActions";
import {postFreeLicenseByLabel} from '../../../../../../../../../../../actions/usersListActions';
import './index.css';

class Labels extends React.Component {

	constructor(props){
		super(props);

		this.state = {
			isMoreLabelsRequested: false
		};

		this.more = this.more.bind(this);
		this.deleteLabelHandler = this.deleteLabelHandler.bind(this);
		this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
	}

	more(e){

		let cTarget = e.currentTarget;

		this.setState((state) => ({
			isMoreLabelsRequested: !state.isMoreLabelsRequested
		}), () => {
			dropDownPosition(document.querySelector('.users'), cTarget.parentNode, cTarget.nextSibling, true)
		});
	}

	deleteLabelHandler(e){
		if (this.props.disabled) {
			return;
		}

		this.props.postFreeLicenseByLabel(
			e.currentTarget.dataset.collaboratorId,
			e.currentTarget.dataset.labelId,
			e.currentTarget.dataset.labelName,
			e.currentTarget.dataset.labelOwnerId
		);
	}

	mouseLeaveHandler(){
		this.setState({
			isMoreLabelsRequested: false
		})
	}

	render() {
		return (
			<div className={`labels d-flex flex-wrap${this.props.disabled ? ' labels--disabled' : ''}`} onMouseLeave={this.mouseLeaveHandler}>
				{
					this.props.collaborator.labels.slice(0, 3).map(label => (
						<div key={label.id + '-' + this.props.collaborator.id} className="badge badge-secondary">
							<p className="badge__label-name">{label.name}</p>
							{
								this.props.collaborator.id !== label.ownerId && this.props.profile.role === "ADMINISTRATOR"
								?
									<span
										onClick={this.props.disabled ? undefined : this.deleteLabelHandler}
										data-label-id={label.id}
										data-label-name={label.name}
										data-label-owner-id={label.ownerId}
										data-collaborator-id={this.props.collaborator.id}
										data-collaborator-email={this.props.collaborator.email}
										data-collaborator-type={this.props.collaborator.type}
										data-collaborator-permission={this.props.collaborator.permission}
										data-tooltip={
											this.props.disabled
												? "Individual actions are disabled while this user is selected for a bulk role update."
												: "Remove this shared label from this user."
										}
										className={`ml-1 remove cf-tooltip-wrap${this.props.disabled ? ' disabled' : ''}`}
										aria-disabled={this.props.disabled}
									>
										×
									</span>
								:
									null
							}
						</div>
					))
				}
				{
					this.props.collaborator.labels.length > 3 ? <Icon onClick={this.more} className="more mx-1" name="ellipsis-h"/> : ""
				}
				{
					this.state.isMoreLabelsRequested
						?
						<div className="more-labels-dropdown">
							{
								this.props.collaborator.labels.slice(3, this.props.collaborator.labels.length).map( label => (
									<div className="d-flex align-items-center justify-content-between" key={label.id + '-' + this.props.collaborator.id}>
										<p>{label.name}</p>
										{
											this.props.collaborator.id !== label.ownerId && this.props.profile.role === "ADMINISTRATOR"
											?
												<button
													onClick={this.props.disabled ? undefined : this.deleteLabelHandler}
													disabled={this.props.disabled}
													data-label-id={label.id}
													data-label-name={label.name}
													data-label-owner-id={label.ownerId}
													data-collaborator-id={this.props.collaborator.id}
													data-collaborator-email={this.props.collaborator.email}
													data-collaborator-type={this.props.collaborator.type}
													data-collaborator-permission={this.props.collaborator.permission}
													className={`remove${this.props.disabled ? ' disabled' : ''}`}
												>
													×
												</button>
											:
												null
										}
									</div>
								))
							}
						</div>
						: null
				}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		profile: state.profileReducer.getProfile
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		putUpdateCollaborators : (object, fromUsersLicensesList) => {
			dispatch(putUpdateCollaborators(object, fromUsersLicensesList))
		},
		postFreeLicenseByLabel : (userId, labelId, labelName, labelOwnerId) => {
			dispatch(postFreeLicenseByLabel(userId, labelId, labelName, labelOwnerId))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(Labels);